import {
  Identifiable,
  Planzone,
  Resource,
  CalendarExportLink,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveCalendarExportLink(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Planzone>, resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<Identifiable<CalendarExportLink>>({
        endpoint: "/calendarLinks",
        method: HttpMethods.POST,
        data: {
          planzone: `planzones/${uuid}`,
          resource: `resources/${resource.uuid}`,
        },
      })
      .then((link) => ({
        ...link,
        uri: link.uuid,
      }));
}

export { saveCalendarExportLink };
